import { useCallback, useState } from 'react'

import { resetCrudSelection } from '@/atoms'
import { deleteDriverAssignments } from '@/features/domain/driverAssignments'
import { useIsUnmounted, useNotification } from '@/hooks'
import { useAppDispatch } from '@/store'
import { unproxify } from '@/utils'

import { useController } from './useController'

export function useDeleteDriverAssignments() {
  const [submitting, setSubmitting] = useState(false)

  const {
    data: { driverAssignmentIds },
    close,
  } = useController()
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const isUnmounted = useIsUnmounted()

  const submit = useCallback(async () => {
    try {
      setSubmitting(true)
      const recurrences = unproxify(driverAssignmentIds)

      const result = await dispatch(deleteDriverAssignments(recurrences))

      if (isUnmounted()) return

      if (!deleteDriverAssignments.fulfilled.match(result)) {
        throw new Error(result.payload?.message ?? 'Internal error')
      }

      resetCrudSelection('driverAssignments')
    } catch (e) {
      toast.error(e.message)
    } finally {
      close?.()
      setSubmitting(false)
    }
  }, [dispatch, toast, driverAssignmentIds, close, isUnmounted])

  return [submitting, submit] as const
}
